import { checkApiResponseDataEquals } from 'reactApp/api/apiHelpers';
import { GiftReceivedAPICall } from 'reactApp/api/billing/gift/GiftReceivedAPICall';
import { ReceivedGiftsUpdate } from 'reactApp/modules/giftReceived/giftReceived.constants';
import ping from 'reactApp/utils/ping';

const request = () => ({
    type: ReceivedGiftsUpdate.REQUEST,
});

const success = (list) => ({
    type: ReceivedGiftsUpdate.SUCCESS,
    list,
});

const failure = (error) => ({
    type: ReceivedGiftsUpdate.FAILURE,
    error,
});

const callApi = () => new GiftReceivedAPICall().makeRequest();

export const updateReceivedGifts = () => (dispatch, getState) => {
    dispatch(request());
    const initialState = getState().purchasedGifts.rawList;

    return new Promise((resolve, reject) => {
        ping({ request: callApi, initialState, check: checkApiResponseDataEquals(initialState) })
            .then(({ data }) => resolve(dispatch(success(data))))
            .catch((error) => reject(dispatch(failure(error))));
    });
};
